import { render, staticRenderFns } from "./examAnalysis.vue?vue&type=template&id=5edf95bc&scoped=true"
import script from "./examAnalysis.vue?vue&type=script&lang=js"
export * from "./examAnalysis.vue?vue&type=script&lang=js"
import style0 from "./examAnalysis.vue?vue&type=style&index=0&id=5edf95bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf95bc",
  null
  
)

export default component.exports